<template>
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_16374_355686)">
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" stroke="#CCCFD7" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5003 15.8832H9.37994L7.78995 9.81737C7.71449 9.53834 7.55425 9.29167 7.31854 9.1754C6.73031 8.88323 6.08212 8.6507 5.375 8.53343V8.2999H8.79067C9.26208 8.2999 9.61564 8.6507 9.67457 9.05813L10.4995 13.4336L12.6188 8.2999H14.6802L11.5003 15.8832ZM15.8588 15.8832H13.8563L15.5052 8.2999H17.5077L15.8588 15.8832ZM20.0984 10.4007C20.1573 9.99228 20.5109 9.75874 20.9233 9.75874C21.5715 9.70011 22.2776 9.81738 22.8669 10.1085L23.2204 8.47581C22.6312 8.24227 21.983 8.125 21.3948 8.125C19.4512 8.125 18.037 9.17541 18.037 10.6332C18.037 11.7423 19.0387 12.3246 19.7458 12.6754C20.5109 13.0252 20.8055 13.2588 20.7466 13.6085C20.7466 14.1332 20.1573 14.3668 19.5691 14.3668C18.8619 14.3668 18.1548 14.1919 17.5077 13.8997L17.1541 15.5335C17.8612 15.8246 18.6262 15.9419 19.3334 15.9419C21.5126 15.9995 22.8669 14.9501 22.8669 13.375C22.8669 11.3915 20.0984 11.2752 20.0984 10.4007ZM29.875 15.8832L28.285 8.2999H26.5772C26.2236 8.2999 25.8701 8.53343 25.7522 8.88323L22.8079 15.8832H24.8693L25.2808 14.7752H27.8136L28.0493 15.8832H29.875ZM26.8718 10.3421L27.46 13.2001H25.8111L26.8718 10.3421Z"
        fill="#172B85"
      />
    </g>
    <defs>
      <clipPath id="clip0_16374_355686">
        <rect width="36" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
